import React, { useEffect, useState } from "react";
import baseUrl from "../../config/baseUrl"
import axios from "axios";
import { Card, CardContent, Box, Typography, TextField, Grid, Button, Drawer, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import TeamsTable from "./TeamsTable";

const Teams = ({ authCreate, authRead, authUpdate, authDelete }) => {

  const auth = sessionStorage.getItem("user");
  const [merchant, setMerchant] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const ReadData = async () => {
    try {
      setLoading(true);
      let values = { 
        page: page
      };
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${auth}`,
        },
      };
      let result = await axios.post(`${baseUrl}/default`, values, config);
      setMessage((result.data.message).toUpperCase());
      setTotalPage(Number(result.data.totalPages));
      const fetchedData = result.data.data;
      setMerchant(fetchedData);
    } catch (error) {
      console.log(error);
    } finally{
      setLoading(false)
    }
  };

  useEffect(() => {
    ReadData();
  }, [page]);

  return (
    <Box>
      <Card variant="outlined">
        <CardContent>
          <Grid 
            container
            spacing={2}
            alignItems="center"  // Align items vertically in the center
            sx={{ marginTop: "10px" }}
          >
            <Grid 
              container
              spacing={2}
              alignItems="flex-start" 
              sx={{ marginTop: "10px" }}
            >
              {/* 1st Row */}
              <Grid item xs={6} sm={10}>
                <Typography variant="h3">MERCHANT TEAM MEMBERS</Typography>
              </Grid>
              {
                authCreate ? (
                    <Grid item xs={6} sm={2}>
                        <AddDrawer />
                    </Grid>
                ) : null
              }
            </Grid>

          </Grid>
          <Box
            sx={{
              overflow: {
                xs: "auto",
                sm: "unset",
              },
            }}
          >
            <TeamsTable merchant={merchant} message={message} page={page} totalPage={totalPage} setPage={setPage} auth={auth} ReadData={ReadData} authRead={authRead} authUpdate={authUpdate} authDelete={authDelete} loading={loading} />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

const AddDrawer = () => {
    const [state, setState] = useState({ right: false });
    
    const roleOptions = [
        { label: "Administrator", value: 1 },
        { label: "Manager", value: 2 },
        { label: "Cashier", value: 3 },
        { label: "Reporter", value: 4 },
    ];

    const roleDescriptions = {
        1: "Administrator\nFull access to UBank Connect. This role allows the same permissions as the Owner, but does not allow access to Owner information. The Admin role should only be assigned to your most trusted and senior employees only.",
        2: "Manager\nLimited access to employee operations and reports. This role should be assigned to mid-level managers who need access to team data but not system-level settings.",
        3: "Cashier\nThis role allows access to perform transactions, manage customer payments, and generate receipts. Cashiers cannot modify system settings or access user data.",
        4: "Reporter\nRead-only access to dashboards, reports, and analytics. Reporters can view but not modify or initiate any operations. Suitable for auditors or oversight personnel."
    };
      
    const [formState, setFormState] = useState({
        fname: '',
        lname: '',
        usercode: '',
        email: '',
        mobile_no: '',
    });

    const resetForm = () => {
        setFormState({
          fname: '',
          lname: '',
          usercode: '',
          email: '',
          mobile_no: '',
        });
    };
    
    const [formIncomplete, setFormIncomplete] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
  
    const auth = sessionStorage.getItem("user");
  
    const toggleDrawer = (open) => () => {
      if (!open) {
        resetForm();
      }
      setState({ right: open });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormState((prevState) => ({
          ...prevState,
          [name]: value,
        }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const requiredFields = {
            'First Name': formState.fname,
            'last Name': formState.lname,
            'Role': formState.usercode,
            'Email': formState.email,
            'Phone Number': formState.mobile_no,
        };
      
          // Find missing fields
        const missingFields = Object.entries(requiredFields)
            .filter(([_, value]) => !value) // Check if the value is empty/null
            .map(([key]) => key); // Get only the field names
      
        if (missingFields.length > 0) {
            setFormIncomplete(true);
            setErrorMessage(`Please fill in all fields: ${missingFields.join(", ")}`);
            setTimeout(() => {
              setFormIncomplete(false);
              setErrorMessage("");
            }, 5000);
            return;
        }
        let values = {
          fname: formState.fname,
          lname: formState.lname,
          email: formState.email,
          usercode: formState.usercode,
          mobile_no: formState.mobile_no,
        };
        const config = {
          headers: {
            "Content-type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${auth}`,
          },
        };
  
        let result = await axios.post(`${baseUrl}/createEmployee`, values, config);
        if (result.status === 200) {
            alert(result.data.message);
          toggleDrawer(false)();
          window.location.reload();
        } else {
            alert(result.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    };
  
    return (
      <div>
        <Button
          variant="contained"
          color="primary"
          sx={{
            mr: 1,
            mb: 1,
          }}
          size="large"
          onClick={toggleDrawer(true)}
        >
          Add
        </Button>
        <Drawer
          anchor="right"
          open={state.right}
          onClose={toggleDrawer (false)}
        >
          <Box
            sx={{ width: {xs: 300, sm: 500} }}
            role="presentation"
          >
            <div style={{ padding: '20px', position: 'relative' }}>
              <h4>NEW EMPLOYEE</h4>
              <button
                style={{
                  position: 'absolute',
                  top: '22px',
                  right: '10px',
                  background: '#ff6600',
                  border: 'none',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  padding: '5px',
                  width: '25px',
                  height: '25px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={toggleDrawer(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-x"
                  style={{
                    display: 'block',
                    width: '100%',
                    height: '100%',
                  }}
                >
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
              <form onSubmit={handleSubmit}>
                <TextField
                  label="First Name"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="fname"
                  value={formState.fname}
                  onChange={handleChange}
                  InputProps={{
                    style: { zIndex: 4}, // Ensure the TextField has the highest z-index
                  }}
                />
                <TextField
                  label="Last Name"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="lname"
                  value={formState.lname}
                  onChange={handleChange}
                  InputProps={{
                    style: { zIndex: 4}, // Ensure the TextField has the highest z-index
                  }}
                />
                <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  type="email"
                  name="email"
                  value={formState.email}
                  onChange={handleChange}
                  InputProps={{
                    style: { zIndex: 4}, // Ensure the TextField has the highest z-index
                  }}
                />
                <TextField
                  label="Phone Number"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="mobile_no"
                  value={formState.mobile_no}
                  onChange={handleChange}
                  InputProps={{
                    style: { zIndex: 4}, // Ensure the TextField has the highest z-index
                  }}
                />
                <FormControl fullWidth margin="normal">
                    <InputLabel id="role-select-label">Role</InputLabel>
                    <Select
                        labelId="role-select-label"
                        value={formState.usercode}
                        name="usercode"
                        label="Role"
                        onChange={handleChange}
                        InputProps={{
                    style: { zIndex: 4}, // Ensure the TextField has the highest z-index
                  }}
                    >
                        {roleOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {formState.usercode && (
                    <Box sx={{ mt: 1, backgroundColor: '#f9f9f9', p: 2, borderRadius: '8px' }}>
                        <Typography variant="subtitle2" gutterBottom>
                        Description
                        </Typography>
                        <Typography variant="body2" color="textSecondary" whiteSpace="pre-line">
                        {roleDescriptions[formState.usercode]}
                        </Typography>
                    </Box>
                )}
                <Button type="submit" variant="contained" color="primary" style={{ marginTop: '20px' }}>
                  Create
                </Button>
                {formIncomplete && (
                  <p style={{ color: "red", textAlign: "center" }}>{errorMessage}</p>
                )}
              </form>
            </div>
          </Box>
        </Drawer>
      </div>
    );
};

export default Teams;